import Fetch from "../../../fetch";
const token = () => "Bearer " + localStorage.getItem("token");

export const getCenters = async params => {
  const route = generateUrl(params, "centers");
  return await Fetch({ route, method: "GET", token: token() });
};

export const create = async values => {
  return await Fetch({
    route: "centers",
    method: "POST",
    token: token(),
    body: JSON.stringify(values)
  });
};

export const update = async ({ id, values }) => {
  return await Fetch({
    route: "centers/" + id,
    method: "PUT",
    token: token(),
    body: JSON.stringify(values)
  });
};

function generateUrl(params, baseUrl) {
  const ret = [];
  for (let key in params) {
    if (params[key] !== "") {
      ret.push(encodeURIComponent(key) + "=" + encodeURIComponent(params[key]));
    }
  }
  const paramString = ret.join("&");
  return paramString ? baseUrl + "?" + paramString : baseUrl;
}
